<template>
  <v-col v-if="blockProducer" cols="auto" class="pr-3 pl-0">
    <chain-b-p-bar-vote-rank :block-producer="blockProducer" />
    <chain-b-p-bar-head-block-producer :block-producer="blockProducer" />
    <chain-b-p-bar-head-block :block-producer="blockProducer" />
    <chain-b-p-bar-cpu-execution-time :hyperion-nodes="hyperionNodes" />
  </v-col>
</template>

<script>
import ChainBPBarVoteRank from './ChainBPBarVoteRank.vue';
import ChainBPBarHeadBlock from './ChainBPBarHeadBlock.vue';
import ChainBPBarHeadBlockProducer from './ChainBPBarHeadBlockProducer.vue';
import ChainBPBarCpuExecutionTime from './ChainBPBarCpuExecutionTime.vue';

export default {
  components: {
    ChainBPBarVoteRank,
    ChainBPBarHeadBlock,
    ChainBPBarHeadBlockProducer,
    ChainBPBarCpuExecutionTime,
  },
  props: {
    blockProducer: {
      type: Object,
      default() {
        return {};
      },
    },
    hyperionNodes: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
